/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//

import * as LocationApi from 'api/Location/LocationApi';
import ListExpandable from 'components/ListExpandable';
import ListRow from 'components/ListExpandable/ListRow';
import { generateUrl, account } from 'api/routes';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@observer
export default class CountriesSitesExpandableList extends React.Component<*> {
  @observable countryLocations: Object = {};

  loadCountryLocations = async (companyId: string, countryId: string) => {
    if (!Object.prototype.hasOwnProperty.call(this.countryLocations, countryId)) {
      this.countryLocations[countryId] = await LocationApi.getCountryLocations(
        companyId,
        countryId
      );
    }

    return this.countryLocations[countryId];
  };

  render(): ?React.Element<*> {
    const { details, t }: Object = this.props;

    if (!details) {
      return null;
    }

    return (
      <section>
        <h3>{this.props.title}</h3>
        {details.locations_count.map((country: Object, key: number) => (
          <ListExpandable
            key={country.country_id}
            title={`${country.country_name} 
                                (${country.locations_count})`}
            onExpand={async () =>
              await this.loadCountryLocations(this.props.companyId, country.country_id)
            }
            render={(countryLocations: Array<*>) => {
              if (!countryLocations) {
                return null;
              }

              return countryLocations.map((location: Object) => {
                const { accountId, companyId } = this.props;
                const path = generateUrl(account.locationsByCompany, [
                  accountId,
                  companyId,
                  country.country_id,
                  location.location_id,
                ]);
                return (
                  <ListRow
                    key={location.location_id}
                    text={location.location_name}
                    textRight={`${location.assets_count} ${t('general:asset', {
                      count: location.assets_count,
                    })}`}
                    button={true}
                    buttonDisabled={location.assets_count < 1}
                    link={true}
                    url={path}
                    buttonText={t('general:actions.view_location')}
                  />
                );
              });
            }}
          />
        ))}
      </section>
    );
  }
}
